'use strict';

module.exports = Backbone.Model.extend({
    defaults: {
        bookingDetail: {
            itinerarySegments: [],
            hasBottomBannerContextualOffers: false,
        },
        imagePath: '',
        utils: {},
    },
    getData() {
        return this.toJSON();
    },
    dataUrl: null,
});
